import { AboutComponent } from '../../components/core/AboutComponent'
import { ContactComponent } from '../../components/core/ContactComponent'
import { HeroComponent3 } from '../../components/core/HeroComponent3'
import { PortfolioComponent } from '../../components/core/PortfolioComponent'
import { ServicesComponent } from '../../components/core/ServicesComponent'
import { TestimonialsComponent } from '../../components/core/TestimonialsComponent'

export function HomePage3() {
  return (
    <div className="min-h-screen bg-background">
      {/* <HeadSpace /> */}
      <HeroComponent3 />
      <ServicesComponent />
      <AboutComponent />
      <PortfolioComponent />
      <TestimonialsComponent />
      {/* <PricingComponent /> */}
      <ContactComponent />
    </div>
  )
}
